/**
 * i18next bootstrap (side-effect module). Catalogs are bundled at build
 * time — CSP-clean, no CDN fetches. Locale persists in `wsr_admin_locale`.
 */
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, normalizeLocale, SUPPORTED_LOCALES } from './constants';
import { readLocaleCookie, writeLocaleCookie } from './localeCookie';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import fr from '@/locales/fr.json';
import pt from '@/locales/pt.json';

const RESOURCES = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  pt: { translation: pt },
} as const;

function resolveInitialLocale() {
  return readLocaleCookie() ?? normalizeLocale(navigator.language) ?? DEFAULT_LOCALE;
}

function applyDocumentLang(lng: string) {
  const normalized = normalizeLocale(lng);
  if (normalized) {
    writeLocaleCookie(normalized);
    document.documentElement.lang = normalized;
    return;
  }
  document.documentElement.lang = DEFAULT_LOCALE;
}

if (!i18next.isInitialized) {
  const initial = resolveInitialLocale();
  document.documentElement.lang = initial;
  i18next.on('languageChanged', applyDocumentLang);
  void i18next.use(initReactI18next).init({
    resources: RESOURCES,
    lng: initial,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    returnNull: false,
    react: { useSuspense: false },
  });
}

export { i18next };
export default i18next;
